import React from 'react';
import packageInfo from '../../../package.json';

export const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();
    const version = packageInfo.version;

    return (
        <footer className="k-pos-relative k-d-flex k-align-items-center k-justify-content-center k-opacity-50 k-mt-26 footer">
            <p className="k-font-size-md k-text-center !k-mb-0 k-px-4 k-py-2">
                v{version} - © {currentYear}, Progress Software. 
            </p>
        </footer>
    );
};
